export default __webpack_public_path__ + "static/media/ClientAdmin.36c1e354.svg";